import { render, staticRenderFns } from "./ManageClose.vue?vue&type=template&id=21f15904&scoped=true"
import script from "./ManageClose.vue?vue&type=script&lang=js"
export * from "./ManageClose.vue?vue&type=script&lang=js"
import style0 from "./ManageClose.vue?vue&type=style&index=0&id=21f15904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f15904",
  null
  
)

export default component.exports